import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { Redirect } from "react-router-dom";
import {
  AppContextConsumer,
  IAppContext,
} from "../../../../components/withAppContext";

const styles = () => ({});

type IProps = IAppContext & WithStyles<keyof ReturnType<typeof styles>>;

const LogoutPage = withStyles(styles)(
  class extends React.Component<IProps> {
    public componentDidMount() {
      this.props.userLogout();
    }

    public render() {
      return this.props.user.id === undefined ? <Redirect to="/" /> : null;
    }
  }
);

export default () => (
  <AppContextConsumer>
    {(context) => <LogoutPage {...context} />}
  </AppContextConsumer>
);



// WEBPACK FOOTER //
// ./src/pages/home/sub-pages/logout-page/LogoutPage.tsx